import { qs, qsa } from "@/utils/dom";
const $elements = qsa('.js-video-autoplay');
export class VideoAutoplay {
    constructor() {
        this.handlers = new WeakMap();
        this.observer = null;
        if ($elements.length === 0)
            return;
        // run on init
        this.initEvents();
        // run on resize
        window.addEventListener('resize', () => {
            this.initEvents();
        });
    }
    initEvents() {
        if (window.innerWidth < 1024) {
            this.removeDesktopEvents();
            // this.mobileEvents();
        }
        else {
            this.desktopEvents();
            // this.removeMobileEvents();
        }
    }
    desktopEvents() {
        this.loop(($element) => {
            if (this.handlers.has($element))
                return; // already attached
            const $video = qs('video', $element);
            if (!$video)
                return;
            const enter = this.handleMouseEnter.bind(this, $video);
            const leave = this.handleMouseLeave.bind(this, $video);
            $element.addEventListener('mouseenter', enter);
            $element.addEventListener('mouseleave', leave);
            this.handlers.set($element, { enter, leave });
        });
    }
    removeDesktopEvents() {
        this.loop(($element) => {
            const handlers = this.handlers.get($element);
            if (!handlers)
                return;
            $element.removeEventListener('mouseenter', handlers.enter);
            $element.removeEventListener('mouseleave', handlers.leave);
            this.handlers.delete($element);
        });
    }
    handleMouseEnter($video) {
        $video.play();
    }
    handleMouseLeave($video) {
        $video.pause();
        $video.currentTime = 0;
    }
    // mobileEvents() {
    //   if (this.observer) return; // already running
    //   this.observer = new IntersectionObserver((entries) => {
    //     entries.forEach((entry) => {
    //       const $video = qs<HTMLVideoElement>('video', entry.target as HTMLElement);
    //       if (!$video) return;
    //       if (entry.isIntersecting) {
    //         $video.play();
    //       } else {
    //         $video.pause();
    //         $video.currentTime = 0;
    //       }
    //     });
    //   }, { threshold: 0.5 });
    //   this.loop(($element) => this.observer.observe($element));
    // }
    // removeMobileEvents() {
    //   if (!this.observer) return;
    //   this.observer.disconnect();
    //   this.observer = null;
    // }
    loop(cb) {
        $elements.forEach(($element) => {
            cb($element);
        });
    }
}
